<template>
    <b-modal
        v-model="openModal"
        :title="modalTitle"
        size="lg"
        ok-title="Save Disciplinary Action"
        ok-variant="success"
        no-fade
        @hide="handleHide"
        @hidden="handleHidden"
        @ok="saveAction"
        :ok-disabled="saving"
        ref="discEditModal"
        :no-close-on-backdrop="true">

        <div v-if="loading" class="text-center">
            Loading <i class="fas fa-spin fa-spinner"></i>
        </div>
        <template v-else>
            <div class="form-group row mb-2">
                <label :class="{ 'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.supervisor_id}">Supervisor:</label>
                <div class="col-sm-8">
                    <div v-if="this.$root.hasPermission('employees.disciplinary.manage')">
                        <user-select :selectedValues="supervisorValues" @vuselected="onUserSelectUpdate" :hasError="errors.supervisor_id ? true : false"></user-select>
                        <span v-if="errors.supervisor_id" class="text-danger">
                            <span v-for="error in errors.supervisor_id">{{ error }}</span>
                        </span>
                    </div>
                    <div v-else>
                        {{ this.$store.state.user.first_name }} {{ this.$store.state.user.last_name }}
                    </div>
                </div>
            </div>

            <div v-bind:class="{ 'form-group': true, 'has-error': errors.employee_id }" class="row mb-2">
                <label :class="{ 'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.employee_id }">
                    Employee: <i class="fa fa-asterisk fa-sm text-danger"></i>
                </label>
                <div class="col-sm-8">

                    <employee-select ref="employeeSelector" :selectedValues="EmployeeValues" @vselected="onEmployeeSelect" :hasError="errors.employee_id ? true : false"></employee-select>

                    <span v-if="errors.employee_id" class="text-danger">
                        <span v-for="error in errors.employee_id">{{ error }}</span>
                    </span>
                </div>
            </div>

            <div v-bind:class="{ 'form-group': true, 'has-error': errors.jobsite_id }" class="row mb-2">
                <label :class="{ 'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.jobsite_id}">Jobsite:</label>
                <div class="col-sm-8">
                    <jobsite-select :selectedValues="selectedJobsite" v-on:vselected="onJobSiteSelectUpdate" :hasError="errors.jobsite_id ? true : false"></jobsite-select>
                    <span v-if="errors.jobsite_id" class="text-danger">
                        <span v-for="error in errors.jobsite_id">{{ error }}</span>
                    </span>
                </div>
            </div>
            <hr/>

            <div class="form-group row mb-2">
                <label :class="{ 'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.disc_action_date }">Date of Violation:</label>
                <div class="col-sm-8">

                    <input type="date" v-model="action.disc_action_date" :class="{'form-control': true, 'is-invalid': errors.disc_action_date}" />

                    <span v-if="errors.disc_action_date" class="text-danger">
                        <span v-for="error in errors.disc_action_date">{{ error }}</span>
                    </span>
                </div>
            </div>
            <div class="form-group row mb-2">
                <label :class="{ 'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.disc_violation_id}">
                    Violation: <i class="fa fa-asterisk fa-sm text-danger"></i>
                </label>
                <div class="col-sm-8">
                    <select v-model="action.disc_violation_id" :class="{'form-control': true, 'is-invalid': errors.disc_violation_id}">
                        <option :value="null">-- Select a Violation Or Check Other --</option>
                        <option v-for="(viol, key) in violations" v-bind:value="viol.disc_violation_id">
                            {{ viol.violation_name }}
                        </option>
                    </select>
                    <div v-if="errors.disc_violation_id" class="text-danger">
                        <span v-for="error in errors.disc_violation_id">{{ error }}</span>
                    </div>
                    <label class="mt-2">
                        <input type="checkbox" v-model="other_violation" value="true" />
                        Other Violation
                    </label>
                </div>
            </div>
            <template v-if="other_violation == true">
                <hr/>
                <div class="form-group row mb-2">
                    <label :class="{ 'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.other_violation_name}">Other Violation Name:</label>
                    <div class="col-sm-8 pt-1">
                        <input type="text" v-model="action.other_violation_name" :class="{'form-control': true, 'is-invalid': errors.other_violation_name}" placeholder="Other Violation Name" />
                        <span v-if="errors.other_violation_name" class="text-danger">
                            <span v-for="error in errors.other_violation_name">{{ error }}</span>
                        </span>
                    </div>
                </div>
                <div class="form-group row mb-2">
                    <label :class="{ 'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.other_penalty_name}">Other Penalty Name:</label>
                    <div class="col-sm-8 pt-1">
                        <input type="text" v-model="action.other_penalty_name" :class="{'form-control': true, 'is-invalid': errors.other_penalty_name}" placeholder="Other Penalty Name" />
                        <span v-if="errors.other_penalty_name" class="text-danger">
                            <span v-for="error in errors.other_penalty_name">{{ error }}</span>
                        </span>
                    </div>
                </div>
                <div class="form-group row mb-2">
                    <label :class="{ 'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.other_bonus_disqual_time}">Safety Bonus Disqualification:</label>
                    <div class="col-sm-8 pt-1">
                        <input type="text" v-model="action.other_bonus_disqual_time" :class="{'form-control': true, 'is-invalid': errors.other_bonus_disqual_time}" placeholder="Other Disqualification Time" />
                        <span v-if="errors.other_bonus_disqual_time" class="text-danger">
                            <span v-for="error in errors.other_bonus_disqual_time">{{ error }}</span>
                        </span>
                    </div>
                </div>
                <hr/>
            </template>
            <div class="form-group row mb-2">
                <label :class="{ 'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.warning_type}">
                    Warning: <i class="fa fa-asterisk fa-sm text-danger"></i>
                </label>
                <div class="col-sm-8 pt-1">
                    <label v-for="(value, key) in warningTypes" class="mr-3">
                        <input type="radio" name="warning_type" v-model="action.warning_type" :value="value" />
                        {{ value }}
                    </label>
                    <span v-if="errors.warning_type" class="text-danger">
                        <span v-for="error in errors.warning_type">{{ error }}</span>
                    </span>
                </div>
            </div>
            <div class="form-group row mb-2">
                <label :class="{ 'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.was_discharged}">Discharged:</label>
                <div class="col-sm-8 pt-1">
                    <b-form-checkbox v-model="action.was_discharged" value="1" plain></b-form-checkbox>
                    <span v-if="errors.was_discharged" class="text-danger">
                        <span v-for="error in errors.was_discharged">{{ error }}</span>
                    </span>
                </div>
            </div>
            <div class="form-group row mb-2">
                <label :class="{ 'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.days_suspension}">Suspension:</label>
                <div class="col-sm-8">
                    <div class="input-group">
                        <input type="text" v-model="action.days_suspension" :class="{'form-control': true, 'is-invalid': errors.days_suspension}" placeholder="Enter the Number of Days Suspension. Decimals Accepted for half days." />
                        <div class="input-group-append">
                            <span class="input-group-text">Days</span>
                        </div>
                    </div>
                    <span v-if="errors.days_suspension" class="text-danger">
                        <span v-for="error in errors.days_suspension">{{ error }}</span>
                    </span>
                </div>
            </div>
            <div class="form-group row mb-2">
                <label :class="{ 'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.files}">File(s):</label>
                <div class="col-sm-8">
                    <b-form-file v-model="files" class="mt-3" multiple placeholder="Attach Written Statements, Lessons Learned, or Other Files"></b-form-file>

                    <span v-if="errors.files" class="text-danger">
                        <span v-for="error in errors.files">{{ error }}</span>
                    </span>

                    <div class="mt-2">
                        <file-list :files="existingFiles" :displayType="'list'"></file-list>
                    </div>
                </div>
            </div>
            <hr/>

            <div class="form-group row mb-4">
                <div class="col-sm-10 offset-sm-1">
                    <label :class="{ 'col-form-label text-sm-right': true, 'text-danger': errors.violation_detail}">Explanation of Violation: <i class="fa fa-asterisk fa-sm text-danger"></i></label>
                    <textarea v-model="action.violation_detail" :class="{'form-control': true, 'is-invalid': errors.violation_detail}" placeholder="Enter an Explanation of the Current Violation" style="min-height: 100px;"></textarea>
                    <span v-if="errors.violation_detail" class="text-danger">
                        <span v-for="error in errors.violation_detail">{{ error }}</span>
                    </span>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-sm-10 offset-sm-1">
                    <label :class="{ 'col-form-label text-sm-right': true, 'text-danger': errors.reason_detail}">What Reason(s) did the employee give for their action?</label>
                    <textarea v-model="action.reason_detail" :class="{'form-control': true, 'is-invalid': errors.reason_detail}" placeholder="Enter the Reason or Reasons the employee gave for their actions." style="min-height: 100px;"></textarea>
                    <span v-if="errors.reason_detail" class="text-danger">
                        <span v-for="error in errors.reason_detail">{{ error }}</span>
                    </span>
                </div>
            </div>
        </template>

    </b-modal>
</template>

<script>
    import moment from 'moment-timezone';

    export default {

        props: {
            id: {
                type: Number,
                default: null,
            },

            incidentId: {
                type: Number,
                default: null,
            },

            fillable: {
                type: Object,
                default: {},
            },
        },

        data: function() {
            return {
                openModal: false,
                loading: true,
                saving: false,
                action: {},
                violations: [],
                warningTypes: {},
                errors: {},
                files: [],
                existingFiles: [],
                other_violation: false,
                previous_actions_loading: false,
                previous_action_days: 180,
                previous_actions: [],
                incentiveFields: [
                    {key: 'violation_name', label: 'Violation'},
                    {key: 'penalty_name', label: 'Penalty'},
                    {key: 'bonus_disqual_time', label: 'Safety Disqual.'},
                ],
            }
        },

        computed: {
            violationOptions(){
                //Options
                var options = {};

                //Send it
                return options;
            },

            warningTypeOptions(){
                //Options
                var options = {};

                for(var i in this.warningTypes)
                {
                    options[this.warningTypes[i]] = this.warningTypes[i];
                }

                //Send it
                return options;
            },

            modalTitle(){
                //Send it
                if(this.action.id)
                {
                    return 'Edit Disciplinary Action';
                }

                return 'Create Disciplinary Action';
            },

            //User Setter
            supervisorValues(){
                //Check for null
                if(!this.action.supervisor_id || this.action.supervisor_id == null)
                {
                    this.action.supervisor_id = this.$store.state.user.user_id;
                    return { supervisor_id: this.$store.state.user.user_id, FirstName: this.$store.state.user.first_name, LastName: this.$store.state.user.last_name };
                }

                //Send it
                return { supervisor_id: this.action.supervisor_id, FirstName: this.action.supervisor_first_name, LastName: this.action.supervisor_last_name};
            },

            EmployeeValues(){
                //check for null
                if(!this.action.employee_id)
                {
                    return null;
                }

                return {EmployeeId: this.action.employee_id, FirstName: this.action.employee_first_name, LastName: this.action.employee_last_name, EmployeeNumber: this.action.employee_number};
            },

            selectedJobsite(){
                //check for null
                if(!this.action.jobsite_id || this.action.jobsite_id == null)
                {
                    //Check the store
                    if(this.$store.state.user.jobsite)
                    {
                        //Set the jobsite
                        var jobsite = this.$store.state.user.jobsite;

                        //Set the HSE jobsite
                        this.action.jobsite_id = jobsite.JobsiteId;

                        //Send it
                        return {JobsiteId: jobsite.JobsiteId, JobsiteNumber: jobsite.JobsiteNumber, JobsiteName: jobsite.JobsiteName};
                    }

                    //Send it
                    return null;
                }

                //Send it
                return {JobsiteId: this.action.jobsite_id, JobsiteNumber: this.action.JobsiteNumber, JobsiteName: this.action.JobsiteName};
            },
        },

        // watch: {
        //     'action.employee_id'(newVal, oldVal){
        //         console.log('test');
        //         //Call loader

        //     },
        // },

        methods: {
            show(){
                //Show it
                this.openModal = true;
            },

            handleHide(bvEvt){
                //debugging
                if(this.$root.debug)
                {
                    //console.log('Hiding Modal');
                }
            },

            handleHidden(bvEvt){
                //Do anything?
            },

            //Get the Action
            getAction(){
                //Send it
                this.$http.get('/employees/disciplinary-actions/edit' + (this.id ? '/'+this.id : ''))
                    .then(res => {
                        //Set the resources
                        this.action = res.data.action;
                        this.violations = res.data.violations;
                        this.warningTypes = res.data.warningTypes;
                        this.existingFiles =res.data.files;

                        //Set some data
                        if(this.id)
                        {
                            this.action = res.data.action;
                            this.other_violation = this.action.disc_violation_id ? false : true;

                            //Set the previous
                            this.$refs.empPreviousActions.setEmployeeId(this.action.employee_id);
                        }
                        else
                        {
                            this.action.disc_violation_id = null;
                        }

                        //Check for fillable Stuff
                        if(this.fillable.supervisor)
                        {
                            //{ supervisor_id: this.action.supervisor_id, FirstName: this.action.supervisor_first_name, LastName: this.action.supervisor_last_name}
                            this.action.supervisor_id = this.fillable.supervisor.supervisor_id;
                            this.action.supervisor_first_name = this.fillable.supervisor.FirstName;
                            this.action.supervisor_last_name = this.fillable.supervisor.LastName;
                        }

                        //Check for fillable Stuff
                        if(this.fillable.jobsite)
                        {
                            //{ supervisor_id: this.action.supervisor_id, FirstName: this.action.supervisor_first_name, LastName: this.action.supervisor_last_name}
                            this.action.JobsiteId = this.fillable.jobsite.JobsiteId;
                            this.action.JobsiteNumber = this.fillable.jobsite.JobsiteNumber;
                            this.action.JobsiteName = this.fillable.jobsite.JobsiteName;
                        }

                        //Check for fillable Stuff
                        if(this.fillable.employee)
                        {
                            //{EmployeeId: this.incident.EmployeeId, FirstName: this.incident.EmpFirstName, LastName: this.incident.EmpLastName, EmployeeNumber: this.incident.EmployeeEmployeeNumber}
                            this.action.EmployeeId = this.fillable.employee.EmployeeId;
                            this.action.EmpFirstName = this.fillable.employee.FirstName;
                            this.action.EmpLastName = this.fillable.employee.LastName;
                            this.action.EmployeeNumber = this.fillable.employee.EmployeeNumber;
                        }
                    })
                    .catch(err => {

                    })
                    .then(() => {
                        //Done loading
                        this.loading = false;
                    });
            },

            saveAction(bvEvt){
                //Stops the modal from closing
                bvEvt.preventDefault();

                //Done loading
                this.saving = true;

                //Setter
                this.action.other_violation = this.other_violation;
                this.action.incidentId = this.incidentId;

                //Send it
                this.$http.postWithFiles('/employees/disciplinary-actions/edit' + (this.id ? '/' + this.id : ''), this.action, this.files)
                    .then(res => {
                        //Alert
                        this.$toastr.success('Disciplinary Action Saved');

                        //Return to main list?
                        this.$emit('actionUpdated', res.data);

                        //Close the modal
                        this.openModal = false;
                    })
                    .catch(error => {
                        //Check for error
                        if(error.response.status === 422)
                        {
                            //Display validation errors
                            this.errors = error.response.data
                        }
                        else
                        {
                            //Alert the user
                            this.$toastr.error(error.response.data, 'Failed to Create Incident');
                        }
                    })
                    .then(() => {
                        //Done loading
                        this.saving = false;
                    });
            },

            onUserSelectUpdate (user){
                //Check for null
                if(user == null)
                {
                    this.action.supervisor_id = null
                    return;
                }

                //Set it
                this.action.supervisor_id = user.UserId;
            },

            onEmployeeSelect(employee){
                //Setter
                this.action.employee_id = employee.EmployeeId;
            },

            onJobSiteSelectUpdate (jobsite) {
              //Check for null
                if(jobsite == null)
                {
                    //Stop
                    this.action.jobsite_id = null;
                    return;
                }

                //Send the value
                this.action.jobsite_id = jobsite.JobsiteId;
                //this.action.JobsiteName = jobsite.JobsiteName;
                //this.action.JobsiteNumber = jobsite.JobsiteNumber;
            },
        },

        mounted() {
            //Get the HSE
            this.getAction();
        }
    }
</script>
